module.exports = __webpack_public_path__ + "media/icons/google-cf93a482.svg";